export default [
  {
    title: 'Parte de horas',
    route: 'partes',
    icon: 'ClockIcon',
  },
  {
    title: 'Política de registro horario',
    route: 'viewPolicy',
  },
]
